//@ts-nocheck
import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination";
import { Params } from "./params";
import { Spec } from "./spec";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    typeUrl: "/lavanet.lava.spec.QueryParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryParamsRequest",
            value: QueryParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsRequest.typeUrl, QueryParamsRequest);
function createBaseQueryParamsResponse() {
    return {
        params: Params.fromPartial({})
    };
}
export const QueryParamsResponse = {
    typeUrl: "/lavanet.lava.spec.QueryParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.is(o.params));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isSDK(o.params));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isAmino(o.params));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = Params.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.params = message.params ? Params.toAmino(message.params) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryParamsResponse",
            value: QueryParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsResponse.typeUrl, QueryParamsResponse);
function createBaseQueryGetSpecRequest() {
    return {
        chainID: ""
    };
}
export const QueryGetSpecRequest = {
    typeUrl: "/lavanet.lava.spec.QueryGetSpecRequest",
    is(o) {
        return o && (o.$typeUrl === QueryGetSpecRequest.typeUrl || typeof o.chainID === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetSpecRequest.typeUrl || typeof o.ChainID === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetSpecRequest.typeUrl || typeof o.ChainID === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetSpecRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetSpecRequest();
        message.chainID = object.chainID ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetSpecRequest();
        if (object.ChainID !== undefined && object.ChainID !== null) {
            message.chainID = object.ChainID;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.ChainID = message.chainID === "" ? undefined : message.chainID;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetSpecRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetSpecRequest.decode(message.value);
    },
    toProto(message) {
        return QueryGetSpecRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryGetSpecRequest",
            value: QueryGetSpecRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetSpecRequest.typeUrl, QueryGetSpecRequest);
function createBaseQueryGetSpecResponse() {
    return {
        spec: Spec.fromPartial({})
    };
}
export const QueryGetSpecResponse = {
    typeUrl: "/lavanet.lava.spec.QueryGetSpecResponse",
    is(o) {
        return o && (o.$typeUrl === QueryGetSpecResponse.typeUrl || Spec.is(o.spec));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryGetSpecResponse.typeUrl || Spec.isSDK(o.Spec));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryGetSpecResponse.typeUrl || Spec.isAmino(o.Spec));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.spec !== undefined) {
            Spec.encode(message.spec, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryGetSpecResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.spec = Spec.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            spec: isSet(object.spec) ? Spec.fromJSON(object.spec) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.spec !== undefined && (obj.spec = message.spec ? Spec.toJSON(message.spec) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryGetSpecResponse();
        message.spec = object.spec !== undefined && object.spec !== null ? Spec.fromPartial(object.spec) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryGetSpecResponse();
        if (object.Spec !== undefined && object.Spec !== null) {
            message.spec = Spec.fromAmino(object.Spec);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.Spec = message.spec ? Spec.toAmino(message.spec) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryGetSpecResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryGetSpecResponse.decode(message.value);
    },
    toProto(message) {
        return QueryGetSpecResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryGetSpecResponse",
            value: QueryGetSpecResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryGetSpecResponse.typeUrl, QueryGetSpecResponse);
function createBaseQueryAllSpecRequest() {
    return {
        pagination: undefined
    };
}
export const QueryAllSpecRequest = {
    typeUrl: "/lavanet.lava.spec.QueryAllSpecRequest",
    is(o) {
        return o && o.$typeUrl === QueryAllSpecRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryAllSpecRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryAllSpecRequest.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.pagination !== undefined) {
            PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllSpecRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            pagination: isSet(object.pagination) ? PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllSpecRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllSpecRequest();
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageRequest.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllSpecRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllSpecRequest.decode(message.value);
    },
    toProto(message) {
        return QueryAllSpecRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryAllSpecRequest",
            value: QueryAllSpecRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllSpecRequest.typeUrl, QueryAllSpecRequest);
function createBaseQueryAllSpecResponse() {
    return {
        spec: [],
        pagination: undefined
    };
}
export const QueryAllSpecResponse = {
    typeUrl: "/lavanet.lava.spec.QueryAllSpecResponse",
    is(o) {
        return o && (o.$typeUrl === QueryAllSpecResponse.typeUrl || Array.isArray(o.spec) && (!o.spec.length || Spec.is(o.spec[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryAllSpecResponse.typeUrl || Array.isArray(o.Spec) && (!o.Spec.length || Spec.isSDK(o.Spec[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryAllSpecResponse.typeUrl || Array.isArray(o.Spec) && (!o.Spec.length || Spec.isAmino(o.Spec[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.spec) {
            Spec.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllSpecResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.spec.push(Spec.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            spec: Array.isArray(object?.spec) ? object.spec.map((e) => Spec.fromJSON(e)) : [],
            pagination: isSet(object.pagination) ? PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.spec) {
            obj.spec = message.spec.map(e => e ? Spec.toJSON(e) : undefined);
        }
        else {
            obj.spec = [];
        }
        message.pagination !== undefined && (obj.pagination = message.pagination ? PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllSpecResponse();
        message.spec = object.spec?.map(e => Spec.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryAllSpecResponse();
        message.spec = object.Spec?.map(e => Spec.fromAmino(e)) || [];
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = PageResponse.fromAmino(object.pagination);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.spec) {
            obj.Spec = message.spec.map(e => e ? Spec.toAmino(e) : undefined);
        }
        else {
            obj.Spec = message.spec;
        }
        obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryAllSpecResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryAllSpecResponse.decode(message.value);
    },
    toProto(message) {
        return QueryAllSpecResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryAllSpecResponse",
            value: QueryAllSpecResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryAllSpecResponse.typeUrl, QueryAllSpecResponse);
function createBaseQueryShowAllChainsRequest() {
    return {};
}
export const QueryShowAllChainsRequest = {
    typeUrl: "/lavanet.lava.spec.QueryShowAllChainsRequest",
    is(o) {
        return o && o.$typeUrl === QueryShowAllChainsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryShowAllChainsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryShowAllChainsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryShowAllChainsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryShowAllChainsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryShowAllChainsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryShowAllChainsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryShowAllChainsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryShowAllChainsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryShowAllChainsRequest",
            value: QueryShowAllChainsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryShowAllChainsRequest.typeUrl, QueryShowAllChainsRequest);
function createBaseQueryShowAllChainsResponse() {
    return {
        chainInfoList: []
    };
}
export const QueryShowAllChainsResponse = {
    typeUrl: "/lavanet.lava.spec.QueryShowAllChainsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryShowAllChainsResponse.typeUrl || Array.isArray(o.chainInfoList) && (!o.chainInfoList.length || ShowAllChainsInfoStruct.is(o.chainInfoList[0])));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryShowAllChainsResponse.typeUrl || Array.isArray(o.chainInfoList) && (!o.chainInfoList.length || ShowAllChainsInfoStruct.isSDK(o.chainInfoList[0])));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryShowAllChainsResponse.typeUrl || Array.isArray(o.chainInfoList) && (!o.chainInfoList.length || ShowAllChainsInfoStruct.isAmino(o.chainInfoList[0])));
    },
    encode(message, writer = BinaryWriter.create()) {
        for (const v of message.chainInfoList) {
            ShowAllChainsInfoStruct.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryShowAllChainsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2:
                    message.chainInfoList.push(ShowAllChainsInfoStruct.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainInfoList: Array.isArray(object?.chainInfoList) ? object.chainInfoList.map((e) => ShowAllChainsInfoStruct.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chainInfoList) {
            obj.chainInfoList = message.chainInfoList.map(e => e ? ShowAllChainsInfoStruct.toJSON(e) : undefined);
        }
        else {
            obj.chainInfoList = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryShowAllChainsResponse();
        message.chainInfoList = object.chainInfoList?.map(e => ShowAllChainsInfoStruct.fromPartial(e)) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryShowAllChainsResponse();
        message.chainInfoList = object.chainInfoList?.map(e => ShowAllChainsInfoStruct.fromAmino(e)) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        if (message.chainInfoList) {
            obj.chainInfoList = message.chainInfoList.map(e => e ? ShowAllChainsInfoStruct.toAmino(e) : undefined);
        }
        else {
            obj.chainInfoList = message.chainInfoList;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryShowAllChainsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryShowAllChainsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryShowAllChainsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryShowAllChainsResponse",
            value: QueryShowAllChainsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryShowAllChainsResponse.typeUrl, QueryShowAllChainsResponse);
function createBaseShowAllChainsInfoStruct() {
    return {
        chainName: "",
        chainID: "",
        enabledApiInterfaces: [],
        apiCount: BigInt(0)
    };
}
export const ShowAllChainsInfoStruct = {
    typeUrl: "/lavanet.lava.spec.ShowAllChainsInfoStruct",
    is(o) {
        return o && (o.$typeUrl === ShowAllChainsInfoStruct.typeUrl || typeof o.chainName === "string" && typeof o.chainID === "string" && Array.isArray(o.enabledApiInterfaces) && (!o.enabledApiInterfaces.length || typeof o.enabledApiInterfaces[0] === "string") && typeof o.apiCount === "bigint");
    },
    isSDK(o) {
        return o && (o.$typeUrl === ShowAllChainsInfoStruct.typeUrl || typeof o.chainName === "string" && typeof o.chainID === "string" && Array.isArray(o.enabledApiInterfaces) && (!o.enabledApiInterfaces.length || typeof o.enabledApiInterfaces[0] === "string") && typeof o.api_count === "bigint");
    },
    isAmino(o) {
        return o && (o.$typeUrl === ShowAllChainsInfoStruct.typeUrl || typeof o.chainName === "string" && typeof o.chainID === "string" && Array.isArray(o.enabledApiInterfaces) && (!o.enabledApiInterfaces.length || typeof o.enabledApiInterfaces[0] === "string") && typeof o.api_count === "bigint");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainName !== "") {
            writer.uint32(10).string(message.chainName);
        }
        if (message.chainID !== "") {
            writer.uint32(18).string(message.chainID);
        }
        for (const v of message.enabledApiInterfaces) {
            writer.uint32(26).string(v);
        }
        if (message.apiCount !== BigInt(0)) {
            writer.uint32(32).uint64(message.apiCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseShowAllChainsInfoStruct();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainName = reader.string();
                    break;
                case 2:
                    message.chainID = reader.string();
                    break;
                case 3:
                    message.enabledApiInterfaces.push(reader.string());
                    break;
                case 4:
                    message.apiCount = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainName: isSet(object.chainName) ? String(object.chainName) : "",
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            enabledApiInterfaces: Array.isArray(object?.enabledApiInterfaces) ? object.enabledApiInterfaces.map((e) => String(e)) : [],
            apiCount: isSet(object.apiCount) ? BigInt(object.apiCount.toString()) : BigInt(0)
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainName !== undefined && (obj.chainName = message.chainName);
        message.chainID !== undefined && (obj.chainID = message.chainID);
        if (message.enabledApiInterfaces) {
            obj.enabledApiInterfaces = message.enabledApiInterfaces.map(e => e);
        }
        else {
            obj.enabledApiInterfaces = [];
        }
        message.apiCount !== undefined && (obj.apiCount = (message.apiCount || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseShowAllChainsInfoStruct();
        message.chainName = object.chainName ?? "";
        message.chainID = object.chainID ?? "";
        message.enabledApiInterfaces = object.enabledApiInterfaces?.map(e => e) || [];
        message.apiCount = object.apiCount !== undefined && object.apiCount !== null ? BigInt(object.apiCount.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseShowAllChainsInfoStruct();
        if (object.chainName !== undefined && object.chainName !== null) {
            message.chainName = object.chainName;
        }
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        message.enabledApiInterfaces = object.enabledApiInterfaces?.map(e => e) || [];
        if (object.api_count !== undefined && object.api_count !== null) {
            message.apiCount = BigInt(object.api_count);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainName = message.chainName === "" ? undefined : message.chainName;
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        if (message.enabledApiInterfaces) {
            obj.enabledApiInterfaces = message.enabledApiInterfaces.map(e => e);
        }
        else {
            obj.enabledApiInterfaces = message.enabledApiInterfaces;
        }
        obj.api_count = message.apiCount !== BigInt(0) ? (message.apiCount?.toString)() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return ShowAllChainsInfoStruct.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ShowAllChainsInfoStruct.decode(message.value);
    },
    toProto(message) {
        return ShowAllChainsInfoStruct.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.ShowAllChainsInfoStruct",
            value: ShowAllChainsInfoStruct.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ShowAllChainsInfoStruct.typeUrl, ShowAllChainsInfoStruct);
function createBaseQueryShowChainInfoRequest() {
    return {
        chainName: ""
    };
}
export const QueryShowChainInfoRequest = {
    typeUrl: "/lavanet.lava.spec.QueryShowChainInfoRequest",
    is(o) {
        return o && (o.$typeUrl === QueryShowChainInfoRequest.typeUrl || typeof o.chainName === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryShowChainInfoRequest.typeUrl || typeof o.chainName === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryShowChainInfoRequest.typeUrl || typeof o.chainName === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainName !== "") {
            writer.uint32(10).string(message.chainName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryShowChainInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainName: isSet(object.chainName) ? String(object.chainName) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainName !== undefined && (obj.chainName = message.chainName);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryShowChainInfoRequest();
        message.chainName = object.chainName ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryShowChainInfoRequest();
        if (object.chainName !== undefined && object.chainName !== null) {
            message.chainName = object.chainName;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainName = message.chainName === "" ? undefined : message.chainName;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryShowChainInfoRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryShowChainInfoRequest.decode(message.value);
    },
    toProto(message) {
        return QueryShowChainInfoRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryShowChainInfoRequest",
            value: QueryShowChainInfoRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryShowChainInfoRequest.typeUrl, QueryShowChainInfoRequest);
function createBaseApiList() {
    return {
        interface: "",
        supportedApis: [],
        addon: ""
    };
}
export const ApiList = {
    typeUrl: "/lavanet.lava.spec.ApiList",
    is(o) {
        return o && (o.$typeUrl === ApiList.typeUrl || typeof o.interface === "string" && Array.isArray(o.supportedApis) && (!o.supportedApis.length || typeof o.supportedApis[0] === "string") && typeof o.addon === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === ApiList.typeUrl || typeof o.interface === "string" && Array.isArray(o.supportedApis) && (!o.supportedApis.length || typeof o.supportedApis[0] === "string") && typeof o.addon === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === ApiList.typeUrl || typeof o.interface === "string" && Array.isArray(o.supportedApis) && (!o.supportedApis.length || typeof o.supportedApis[0] === "string") && typeof o.addon === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.interface !== "") {
            writer.uint32(34).string(message.interface);
        }
        for (const v of message.supportedApis) {
            writer.uint32(42).string(v);
        }
        if (message.addon !== "") {
            writer.uint32(50).string(message.addon);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApiList();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 4:
                    message.interface = reader.string();
                    break;
                case 5:
                    message.supportedApis.push(reader.string());
                    break;
                case 6:
                    message.addon = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            interface: isSet(object.interface) ? String(object.interface) : "",
            supportedApis: Array.isArray(object?.supportedApis) ? object.supportedApis.map((e) => String(e)) : [],
            addon: isSet(object.addon) ? String(object.addon) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.interface !== undefined && (obj.interface = message.interface);
        if (message.supportedApis) {
            obj.supportedApis = message.supportedApis.map(e => e);
        }
        else {
            obj.supportedApis = [];
        }
        message.addon !== undefined && (obj.addon = message.addon);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseApiList();
        message.interface = object.interface ?? "";
        message.supportedApis = object.supportedApis?.map(e => e) || [];
        message.addon = object.addon ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseApiList();
        if (object.interface !== undefined && object.interface !== null) {
            message.interface = object.interface;
        }
        message.supportedApis = object.supportedApis?.map(e => e) || [];
        if (object.addon !== undefined && object.addon !== null) {
            message.addon = object.addon;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.interface = message.interface === "" ? undefined : message.interface;
        if (message.supportedApis) {
            obj.supportedApis = message.supportedApis.map(e => e);
        }
        else {
            obj.supportedApis = message.supportedApis;
        }
        obj.addon = message.addon === "" ? undefined : message.addon;
        return obj;
    },
    fromAminoMsg(object) {
        return ApiList.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return ApiList.decode(message.value);
    },
    toProto(message) {
        return ApiList.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.ApiList",
            value: ApiList.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(ApiList.typeUrl, ApiList);
function createBaseQueryShowChainInfoResponse() {
    return {
        chainID: "",
        interfaces: [],
        supportedApisInterfaceList: [],
        optionalInterfaces: []
    };
}
export const QueryShowChainInfoResponse = {
    typeUrl: "/lavanet.lava.spec.QueryShowChainInfoResponse",
    is(o) {
        return o && (o.$typeUrl === QueryShowChainInfoResponse.typeUrl || typeof o.chainID === "string" && Array.isArray(o.interfaces) && (!o.interfaces.length || typeof o.interfaces[0] === "string") && Array.isArray(o.supportedApisInterfaceList) && (!o.supportedApisInterfaceList.length || ApiList.is(o.supportedApisInterfaceList[0])) && Array.isArray(o.optionalInterfaces) && (!o.optionalInterfaces.length || typeof o.optionalInterfaces[0] === "string"));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryShowChainInfoResponse.typeUrl || typeof o.chainID === "string" && Array.isArray(o.interfaces) && (!o.interfaces.length || typeof o.interfaces[0] === "string") && Array.isArray(o.supportedApisInterfaceList) && (!o.supportedApisInterfaceList.length || ApiList.isSDK(o.supportedApisInterfaceList[0])) && Array.isArray(o.optional_interfaces) && (!o.optional_interfaces.length || typeof o.optional_interfaces[0] === "string"));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryShowChainInfoResponse.typeUrl || typeof o.chainID === "string" && Array.isArray(o.interfaces) && (!o.interfaces.length || typeof o.interfaces[0] === "string") && Array.isArray(o.supportedApisInterfaceList) && (!o.supportedApisInterfaceList.length || ApiList.isAmino(o.supportedApisInterfaceList[0])) && Array.isArray(o.optional_interfaces) && (!o.optional_interfaces.length || typeof o.optional_interfaces[0] === "string"));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        for (const v of message.interfaces) {
            writer.uint32(18).string(v);
        }
        for (const v of message.supportedApisInterfaceList) {
            ApiList.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.optionalInterfaces) {
            writer.uint32(34).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryShowChainInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.interfaces.push(reader.string());
                    break;
                case 3:
                    message.supportedApisInterfaceList.push(ApiList.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.optionalInterfaces.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            chainID: isSet(object.chainID) ? String(object.chainID) : "",
            interfaces: Array.isArray(object?.interfaces) ? object.interfaces.map((e) => String(e)) : [],
            supportedApisInterfaceList: Array.isArray(object?.supportedApisInterfaceList) ? object.supportedApisInterfaceList.map((e) => ApiList.fromJSON(e)) : [],
            optionalInterfaces: Array.isArray(object?.optionalInterfaces) ? object.optionalInterfaces.map((e) => String(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        if (message.interfaces) {
            obj.interfaces = message.interfaces.map(e => e);
        }
        else {
            obj.interfaces = [];
        }
        if (message.supportedApisInterfaceList) {
            obj.supportedApisInterfaceList = message.supportedApisInterfaceList.map(e => e ? ApiList.toJSON(e) : undefined);
        }
        else {
            obj.supportedApisInterfaceList = [];
        }
        if (message.optionalInterfaces) {
            obj.optionalInterfaces = message.optionalInterfaces.map(e => e);
        }
        else {
            obj.optionalInterfaces = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryShowChainInfoResponse();
        message.chainID = object.chainID ?? "";
        message.interfaces = object.interfaces?.map(e => e) || [];
        message.supportedApisInterfaceList = object.supportedApisInterfaceList?.map(e => ApiList.fromPartial(e)) || [];
        message.optionalInterfaces = object.optionalInterfaces?.map(e => e) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryShowChainInfoResponse();
        if (object.chainID !== undefined && object.chainID !== null) {
            message.chainID = object.chainID;
        }
        message.interfaces = object.interfaces?.map(e => e) || [];
        message.supportedApisInterfaceList = object.supportedApisInterfaceList?.map(e => ApiList.fromAmino(e)) || [];
        message.optionalInterfaces = object.optional_interfaces?.map(e => e) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.chainID = message.chainID === "" ? undefined : message.chainID;
        if (message.interfaces) {
            obj.interfaces = message.interfaces.map(e => e);
        }
        else {
            obj.interfaces = message.interfaces;
        }
        if (message.supportedApisInterfaceList) {
            obj.supportedApisInterfaceList = message.supportedApisInterfaceList.map(e => e ? ApiList.toAmino(e) : undefined);
        }
        else {
            obj.supportedApisInterfaceList = message.supportedApisInterfaceList;
        }
        if (message.optionalInterfaces) {
            obj.optional_interfaces = message.optionalInterfaces.map(e => e);
        }
        else {
            obj.optional_interfaces = message.optionalInterfaces;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return QueryShowChainInfoResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryShowChainInfoResponse.decode(message.value);
    },
    toProto(message) {
        return QueryShowChainInfoResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.spec.QueryShowChainInfoResponse",
            value: QueryShowChainInfoResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryShowChainInfoResponse.typeUrl, QueryShowChainInfoResponse);
